import { render, staticRenderFns } from "./AcademyCurriculumUnits.vue?vue&type=template&id=5c320ff0&scoped=true&lang=pug&"
import script from "./AcademyCurriculumUnits.vue?vue&type=script&lang=ts&"
export * from "./AcademyCurriculumUnits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c320ff0",
  null
  
)

export default component.exports